import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=2ad1b5f5&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=2ad1b5f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad1b5f5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('C:/app/components/Svgs/Logo.vue').default})
